import { motion } from 'framer-motion';
import type { FC, ReactNode } from 'react';

const FadeIn: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.2 }}
      exit={{ opacity: 0 }}>
      {children}
    </motion.div>
  );
};

export default FadeIn;
